import React, { useState, useCallback } from "react";
import axios from "axios";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Change from "../../Common/StringToSub";
import { Container, Row, Col } from "react-bootstrap";
import { BiFilter } from "react-icons/bi";
import { GrPowerReset } from "react-icons/gr";
import { useDispatch, useSelector } from "react-redux";
import PaginationComponent from "../../Component/Pagination/PaginationControls";
import moment from "moment";
import debounce from "lodash.debounce";
import { HiDownload } from "react-icons/hi";
import { IoIosEye } from "react-icons/io";
import { Modal, Button } from "react-bootstrap";
// import ExportExcel from "../../Component/ExportExcel/ExportExcel";
import Popup from "reactjs-popup";
import apiCall from "../../API/API";
import {
  releasedIncome,
  fetchAllTransaction,
} from "../../Actions/adminActions";
import { toast, ToastContainer } from "react-toastify";
const PendingIncome = () => {
  const [data, setData] = useState([]);
  const { paymentRequests } = useSelector((state) => state.admin);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filter, setFilter] = useState("none");
  const [selectWallet, setSelectWallet] = useState("roi_income");
  const [targetWallet, setTargetWallet] = useState("main_wallet");
  const [search, setsearch] = useState({
    source: selectWallet,
    release: "0",
    amount: "",
    username: "",
    search: "",
    startDate: "",
    endDate: "",
    uid: "",
  });

  const [limitFilter, setLimitFilter] = useState(20);
  const [dateFilter, setDateFilter] = useState("default");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [incomes, setIncomes] = useState([]);

  const fetchIncome = async () => {
    try {
      const { data, error } = await apiCall("GET", "/get_wallets");
      if (data) {
        console.log("wallets==>", data?.wallets);
        setIncomes(data?.wallets);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  useEffect(() => {
    fetchIncome();
  }, []);

  const fetchWithdraw = useCallback(
    debounce((params) => {
      dispatch(fetchAllTransaction(params));
    }, 500),
    [dispatch]
  );

  const toggleFilter = () => {
    if (filter === "none") {
      setFilter("flex");
    } else {
      setFilter("none");
    }
  };
  useEffect(() => {
    setsearch((prev) => ({
      ...prev,
      source: selectWallet,
    }));
  }, [selectWallet]);

  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "startDate") {
      setStartDate(value);
    } else if (name === "endDate") {
      setEndDate(value);
    } else {
      setsearch((prev) => {
        const updatedSearch = { ...prev, [name]: value };
        Object.keys(updatedSearch).forEach((key) => {
          if (updatedSearch[key] === "" || updatedSearch[key] === 0) {
            delete updatedSearch[key];
          }
        });
        return updatedSearch;
      });
    }
    setCurrentPage(1);
    fetchWithdraw({
      page: 1,
      limit: limitFilter,
      ...Object.fromEntries(
        Object.entries(search).filter(
          ([_, value]) => value !== "" && value !== 0
        )
      ),
      ...(startDate && endDate ? { startDate, endDate } : {}),
    });
  };
  const handleLimitChange = (e) => {
    setLimitFilter(e.target.value);
  };

  const handleDateFilterChange = (e) => {
    const value = e.target.value;
    setDateFilter(value);
    const today = moment().endOf("day");
    let start = "";
    let end = "";
    switch (value) {
      case "today":
        start = today.startOf("day").format("YYYY-MM-DD");
        end = today.format("YYYY-MM-DD");
        break;
      case "yesterday":
        start = today.subtract(1, "days").startOf("day").format("YYYY-MM-DD");
        end = today.endOf("day").format("YYYY-MM-DD");
        break;
      case "this_week":
        start = today.startOf("week").format("YYYY-MM-DD");
        end = today.endOf("week").format("YYYY-MM-DD");
        break;
      case "this_month":
        start = today.startOf("month").format("YYYY-MM-DD");
        end = today.endOf("month").format("YYYY-MM-DD");
        break;
      default:
        start = "";
        end = "";
        break;
    }
    setStartDate(start);
    setEndDate(end);
  };

  const Addfilter = () => {
    const queryParams = {
      page: currentPage,
      limit: limitFilter,
      ...Object.fromEntries(
        Object.entries(search).filter(
          ([_, value]) => value !== "" && value !== 0
        )
      ),
    };

    if (startDate) {
      queryParams.startDate = startDate;
    }
    if (endDate) {
      queryParams.endDate = endDate;
    }

    dispatch(fetchAllTransaction(queryParams));
  };

  const resetFilter = () => {
    setsearch({
      source: selectWallet,
      release: "0",
      amount: "",
      username: "",
      search: "",
      startDate: "",
      endDate: "",
      uid: "",
    });
    setLimitFilter(20);
    setStartDate("");
    setEndDate("");
    setDateFilter("default");
    setCurrentPage(1);

    dispatch(
      fetchAllTransaction({
        page: 1,
        limit: 20,
        source: selectWallet,
        release: 0,
      })
    );
  };

  useEffect(() => {
    const queryParams = {
      page: currentPage,
      limit: 20,
      ...Object.fromEntries(
        Object.entries(search).filter(
          ([_, value]) => value !== "" && value !== 0
        )
      ),
    };
    if (startDate && endDate) {
      queryParams.startDate = startDate;
      queryParams.endDate = endDate;
    }
    fetchWithdraw(queryParams);
  }, [dispatch, currentPage, limitFilter, search, startDate, endDate]);

  useEffect(() => {
    // setTotalRecords(paymentRequests?.totalRecords);
    setTotalPages(paymentRequests?.totalPages);
  }, [paymentRequests]);

  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showRejectionReason, setShowRejectionReason] = useState(false);
  const [showReason, setShowReason] = useState(false);
  const [currentTxId, setCurrentTxId] = useState(null);
  const [rejectionReason, setRejectionReason] = useState("");
  const [showApproveAllModal, setShowApproveAllModal] = useState(false);
  const [currentApproveTxId, setCurrentApproveTxId] = useState(null);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [currentApproveData, setCurrentApproveData] = useState({});
  const [tx_Ids, setTx_Ids] = useState([]);

  const toggleSelectAll = () => {
    setSelectAll(!selectAll);
    // console.log(selectAll);
    if (!selectAll) {
      const allIndexes = paymentRequests?.data?.map((_, index) => index) || [];
      const allTxIds = paymentRequests?.data?.map((row) => row.tx_Id) || [];

      setSelectedRows(allIndexes);
      setTx_Ids(allTxIds);
    } else {
      setSelectedRows([]);
      setTx_Ids([]);
    }
    setSelectAll(!selectAll);
  };

  const toggleSelectRow = (index, tx_Id) => {
    setSelectedRows((prevSelected) => {
      const newSelected = prevSelected.includes(index)
        ? prevSelected.filter((rowIndex) => rowIndex !== index)
        : [...prevSelected, index];

      setSelectAll(newSelected.length === paymentRequests?.data?.length); // Update "Select All" state

      return newSelected;
    });

    setTx_Ids((prevTxIds) => {
      const newTxIds = prevTxIds.includes(tx_Id)
        ? prevTxIds.filter((id) => id !== tx_Id)
        : [...prevTxIds, tx_Id];

      return newTxIds;
    });
  };

  useEffect(() => {
    console.log("Selected Rows Updated:", selectedRows);
  }, [selectedRows]);

  //   const toggleSelectRow = (index, tx_Id) => {
  //     if (selectedRows.includes(index)) {
  //       setSelectedRows(selectedRows.filter((rowIndex) => rowIndex !== index));
  //       setTx_Ids(tx_Ids.filter((rowIndex) => rowIndex !== tx_Id));
  //     } else {
  //       setSelectedRows([...selectedRows, index]);
  //       setTx_Ids([...tx_Ids, tx_Id]);
  //     }
  //   };

  const handleReleaseIncome = () => {
    if (tx_Ids.length == 0) {
      toast.error("Select the transaction ids!");
    } else {
      setShowApproveAllModal(true);
    }
  };

  const handleApproveAll = async () => {
    try {
      console.log("body==>", tx_Ids, selectWallet, targetWallet);

      const body = {
        requestIds: tx_Ids,
        income: [selectWallet],
        // target_wallet: "main_wallet",
      };
      console.log("body", body);
      const response = await apiCall("POST", "/release_income", body);
      //   await dispatch(releasedIncome(tx_Ids, [selectWallet], targetWallet));
      if (response?.data) {
        setShowApproveAllModal(false);
        toast.success(response.data.message);
        dispatch(
          fetchAllTransaction({
            page: currentPage,
            limit: limitFilter,
            source: selectWallet,
            release: 0,
          })
        );
        setTargetWallet("main_wallet");
        setSelectedRows([]);
        setTx_Ids([]);
        setSelectAll(false);
        console.log("selectedRows", selectedRows);
      } else {
        setShowApproveAllModal(false);
        toast.error(
          response?.error?.response?.data?.error
          //   ||
          //     "If income includes roi_income or hybrid_roi_income, target_wallet must be roi_wallet."
        );
        setTargetWallet("main_wallet");
        setTx_Ids([]);
      }
    } catch (e) {
      console.log(e);
      toast.error(e?.response?.data?.error);
    }
  };

  const handleCancelApproveAll = () => {
    setShowApproveAllModal(false);
  };

  return (
    <React.Fragment>
      <Container>
        <div className="pagePath">
          <h4 className="m-0">Home/Pending Income</h4>
        </div>
        <div style={{ display: "flex", justifyContent: "end" }}>
          <select
            name="selectWallet"
            value={selectWallet}
            style={{ borderRadius: "5px" }}
            onChange={(e) => setSelectWallet(e.target.value)}
          >
            {/* <option value="select">--Select Income--</option> */}
            {incomes?.map((x, i) => {
              if (x?.wallet_type === "income") {
                return (
                  <option key={i} value={x?.slug} style={{color: "white"}}>
                    {x?.name}
                  </option>
                );
              }
              return null;
            })}
          </select>
        </div>
        <Row id="filterRow">
          <span className="filterL">
            <div className="d-flex justify-content-between">
              <div onClick={() => toggleFilter()}>
                <i>
                  <BiFilter />
                </i>
                Filter
              </div>
              <div className="align-content-center">
                Total Debited Amount : {paymentRequests?.creditSum}
              </div>
            </div>
          </span>

          <Row className="p-0 m-0" style={{ display: filter }}>
            <Col lg="2" md="4">
              <div>
                <input
                  type="text"
                  name="search"
                  placeholder="Search By Name, Username"
                  value={search.search}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="text"
                  placeholder="Search User By Uid"
                  name="uid"
                  value={search.uid}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="number"
                  name="amount"
                  placeholder="Search By Amount"
                  value={search.amount}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="date"
                  name="startDate"
                  placeholder="Start Date"
                  value={startDate}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="date"
                  name="endDate"
                  placeholder="End Date"
                  value={endDate}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <select
                  name="dateFilter"
                  value={dateFilter}
                  onChange={handleDateFilterChange}
                >
                  <option value="default">Default</option>
                  <option value="today">Today</option>
                  <option value="yesterday">Yesterday</option>
                  <option value="this_week">This Week</option>
                  <option value="this_month">This Month</option>
                </select>
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <select
                  name=""
                  value={limitFilter}
                  onChange={handleLimitChange}
                >
                  <option value="">--All--</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                </select>
              </div>
            </Col>
            <div>
              <button className="save filter" onClick={Addfilter}>
                Filter{" "}
                <i>
                  <BiFilter />
                </i>
              </button>
              <button className="cancel reset" onClick={resetFilter}>
                Reset{" "}
                <i>
                  <GrPowerReset />
                </i>
              </button>
            </div>
          </Row>
        </Row>
        <div id="directIncomeDiv">
          <div className="button-container">
            <button className="action-btn" onClick={handleReleaseIncome}>
              Release Income
            </button>
          </div>
          <Modal show={showApproveAllModal} onHide={handleCancelApproveAll}>
            <Modal.Header closeButton>
              <Modal.Title>Confirm Release Income</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Are you sure you want to release the Income?</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCancelApproveAll}>
                Cancel
              </Button>
              <Button variant="primary" onClick={handleApproveAll}>
                Approve All
              </Button>
            </Modal.Footer>
          </Modal>
          <Row id="directTableRow" className="text-center">
            <Col md="12" className="p-0">
              <div style={{ width: "100%", display: "flex" }}>
                <table>
                  <tr>
                    <th>
                      <div className="checkbox-cell">
                        <input
                          type="checkbox"
                          checked={selectAll}
                          onChange={toggleSelectAll}
                          className="checkbox-input"
                          id="selectAll"
                        />
                        <label htmlFor="selectAll" className="checkbox-label">
                          <span
                            className={`custom-checkbox ${
                              selectAll ? "checked" : ""
                            }`}
                          />
                          <span className="checkbox-text">Select All</span>
                        </label>
                      </div>
                    </th>
                    <th>S. No.</th>
                    <th>Name</th>
                    <th>Username</th>
                    <th>Uid</th>
                    <th>Amount</th>
                    <th>From (Name)</th>
                    <th>Status</th>
                    <th>Date</th>
                  </tr>
                  {paymentRequests?.data?.map((row, index) => (
                    <tr key={index}>
                      <td>
                        <div className="checkButton">
                          <input
                            type="checkbox"
                            checked={selectedRows.includes(index)}
                            onChange={() => toggleSelectRow(index, row.tx_Id)}
                            className="checkbox-input"
                            id={`row-${index}`}
                          />
                          <label
                            htmlFor={`row-${index}`}
                            className="checkbox-label1"
                          >
                            <span
                              className={`custom-checkbox ${
                                selectedRows.includes(index) ? "checked" : ""
                              }`}
                            />
                          </label>
                        </div>
                      </td>
                      <td>{index + 1 + 20 * (currentPage - 1)}</td>
                      <td>{row.name}</td>
                      <td>{row.username}</td>
                      <td>{row?.uid}</td>
                      <td>{parseFloat(row.amount).toFixed(2)}</td>
                      <td>
                        {row.from} ({row.name})
                      </td>
                      <td>
                        {row.release === 0
                          ? "Pending"
                          : row.release === 1
                          ? "Released"
                          : null}
                      </td>
                      <td>
                        {moment(row?.createdAt).format(
                          "DD-MM-YYYY   &   HH:mm"
                        )}
                      </td>
                    </tr>
                  ))}
                </table>
              </div>
            </Col>
          </Row>
        </div>
        <Row>
          <Col md="12">
            {
              <PaginationComponent
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePagination}
              />
            }
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default PendingIncome;
